import { apiSlice } from "../api/apiSlice";
import {GetCountryListAction, GetZipCodeListAction} from "./masterslice";

export const mastersApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getCountries: builder.query({
            query: () => "Country",
            async onQueryStarted(args, { queryFulfilled, dispatch }) {
              try {
                const result = await queryFulfilled;
                if (result.data) {
                  dispatch(GetCountryListAction(result.data));
                }
              } catch (err) {}
            },
          }),

        getPostalCode: builder.query({
          query: () => "ZipCodes",
          async onQueryStarted(args, { queryFulfilled, dispatch }) {
            try {
              const result = await queryFulfilled;
              if (result.data) {
                dispatch(GetZipCodeListAction(result.data));
              }
            } catch (err) {}
          },
        }),
    }),
  });
  
  export const {
    useLazyGetCountriesQuery,
    useLazyGetPostalCodeQuery
  } = mastersApi;